export const ERROR_MESSAGE = "ERROR_MESSAGE";
export const INFORMATION_MESSAGE = "INFORMATION_MESSAGE";
export const DEFAULT_MESSAGE = "DEFAULT_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
